export const LOGIN_ACTION = "login_action";
export const LOGOUT_ACTION = "logout_action";
export const SET_LOGIN_DETAILS = "set_login_details";
export const SET_PROFILE_IMAGE = "set_profile_image";
export const IS_CHANGE_PASSWORD_SUCCESS = "is_change_password_success"
